"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var FormFieldContainer_1 = __importDefault(require("../FormFieldContainer/FormFieldContainer"));

var LoadingIndicator_1 = require("../LoadingIndicator");

var RenderError_1 = require("../RenderError/RenderError");

var styled_1 = require("../styled");

var FormInput =
/** @class */
function (_super) {
  __extends(FormInput, _super);

  function FormInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isActive: false,
      isError: _this.props.isError || false,
      isSecure: _this.props.isSecure || false
    };

    _this.toggleActive = function () {
      _this.setState(function (prevState) {
        return {
          isActive: !prevState.isActive
        };
      });
    };

    _this.toggleSecure = function () {
      _this.setState(function (prevState) {
        return {
          isSecure: !prevState.isSecure
        };
      });
    };

    _this.handleChange = function (value) {
      var _a = _this.props,
          setFieldValue = _a.setFieldValue,
          onChangeText = _a.onChangeText,
          name = _a.name,
          isSubmitting = _a.isSubmitting;

      if (!isSubmitting) {
        setFieldValue(name, value);

        if (onChangeText) {
          onChangeText();
        }
      }
    };

    _this.handleBlur = function () {
      var _a = _this.props,
          setFieldTouched = _a.setFieldTouched,
          name = _a.name,
          onBlur = _a.onBlur;
      setFieldTouched(name);

      _this.toggleActive();

      if (onBlur) {
        onBlur();
      }
    }; // has the logic for handling the form submit on enter keypress


    _this.handleKeyPress = function (event) {
      event.preventDefault();
      var key = event.key;
      var _a = _this.props,
          handleSubmit = _a.handleSubmit,
          setFieldTouched = _a.setFieldTouched,
          name = _a.name,
          values = _a.values,
          isValid = _a.isValid,
          onBlur = _a.onBlur,
          preventSubmitOnEnter = _a.preventSubmitOnEnter;
      var enterKey = 'Enter';
      var isEnter = key === enterKey;
      var shouldHandle = !preventSubmitOnEnter && isEnter;

      if (shouldHandle && values[name] && isValid && !onBlur) {
        handleSubmit();
      } else if (isEnter && values[name] && onBlur) {
        onBlur();
      } else if (isEnter) {
        setFieldTouched(name);
      }
    };

    return _this;
  }

  FormInput.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        onTouchStart = _a.onTouchStart,
        editable = _a.editable,
        touched = _a.touched,
        value = _a.value,
        values = _a.values,
        errors = _a.errors,
        label = _a.label,
        placeholder = _a.placeholder,
        name = _a.name,
        linkedField = _a.linkedField,
        allowPasswordReveal = _a.allowPasswordReveal,
        onChange = _a.onChange,
        isSecure = _a.isSecure,
        isLoading = _a.isLoading,
        isDisabled = _a.isDisabled,
        onFocus = _a.onFocus,
        isSubmitting = _a.isSubmitting,
        maxLength = _a.maxLength,
        multiline = _a.multiline,
        numberOfLines = _a.numberOfLines,
        accessibilityLabel = _a.accessibilityLabel;
    var isError = !isLoading && (this.state.isError || touched[name] && errors[name] || linkedField && errors[linkedField]);
    var keyPressHandler = react_native_1.Platform.select({
      web: this.handleKeyPress
    });
    return react_1.default.createElement(FormFieldContainer_1.default, null, react_1.default.createElement(styled_1.StyledInputLabel, null, label || placeholder), react_1.default.createElement(styled_1.RowWrapper, null, react_1.default.createElement(styled_1.StyledTextInput, {
      value: value || values[name],
      onChangeText: this.handleChange,
      onChange: onChange,
      placeholder: placeholder || '',
      onFocus: onFocus ? onFocus : this.toggleActive,
      onBlur: this.handleBlur,
      editable: editable || !isSubmitting,
      onTouchStart: onTouchStart,
      secureTextEntry: this.state.isSecure,
      isActive: this.state.isActive,
      isError: isError,
      isDisabled: isDisabled || isSubmitting,
      onKeyPress: keyPressHandler,
      maxLength: maxLength,
      multiline: multiline,
      numberOfLines: numberOfLines,
      accessibilityLabel: accessibilityLabel
    }), isSecure && allowPasswordReveal ? react_1.default.createElement(styled_1.EyeIcon, {
      action: function action() {
        return _this.toggleSecure();
      },
      isSecure: this.state.isSecure
    }) : null, react_1.default.createElement(styled_1.ValidationIconWrapper, null, isLoading ? react_1.default.createElement(LoadingIndicator_1.LoadingIndicator, {
      size: 'small'
    }) : touched[name] ? react_1.default.createElement(styled_1.ValidationIcon, {
      isValid: !isError
    }) : null)), this.props.children, react_1.default.createElement(react_native_1.View, null, !isLoading && isError && react_1.default.createElement(RenderError_1.RenderError, {
      errorText: errors[name]
    }), !isLoading && linkedField && errors[linkedField] && react_1.default.createElement(RenderError_1.RenderError, {
      errorText: errors[linkedField]
    })));
  };

  return FormInput;
}(react_1.default.Component);

exports.FormInput = FormInput;